import styled from '@emotion/styled'

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
  width: fit-content;
`

const OptionWrapper = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
  gap: 24px;
`

const Option = styled.button`
  padding: 8px;
  background-color: #fafafb;
  border: 1px solid #d2d2d9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 8px;

  &:hover {
    cursor: pointer;
    border-color: #e7e5e9;
    background-color: #f3f2f4;
  }

  &:active,
  &:focus {
    outline: none;
    padding: 6px;
    border: solid 3px #4a4a68;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #fafafb;
    border: 1px solid #d2d2d9;
  }

  > strong {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: 0.05em;
  }

  > span {
    font-size: 12px;
    font-weight: 400;
    color: #77778e;
    line-height: 150%;
    text-align: center;

    > a {
      color: #77778e;
      font-weight: 600;
      text-decoration: underline;
    }
  }
`

export { Root, OptionWrapper, Option }
